// extracted by mini-css-extract-plugin
module.exports = {"block":"BlockContainer_block__2Pwee","blockId":"BlockContainer_blockId__flDGT"};